import React from "react";
import { useTheme } from "@mui/styles";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  container: {
    display: "flex",
    width: { md: "700px", lg: "900px", xl: "1198px" },
    justifyContent: "space-around",
    mt: { md: "30px", lg: "40px", xl: "52px" },
    mb: { md: "11rem", lg: "11rem", xl: "13rem" },
  },
  child: {
    display: "flex",
    flexDirection: "column",
  },
  innerBox: { display: "flex" },
  greenCheck: {
    width: "21px",
  },
  typography: {
    fontSize: { md: "22px", lg: "26px", xl: "34px" },
    lineHeight: { md: "46px", xl: "55px" },
    fontFamily: theme.typography.anaHeim.regular,
    color: theme.palette.white.main,
    ml: { md: "8px" },
  },
});

const TopicsDesktop = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { pathname } = useLocation();
  const { topics, greenCheck } = useTranslation(pathname, "TopicsDesktop");

  return (
    <Box sx={classes.container}>
      <Box sx={classes.child}>
        <Box sx={classes.innerBox}>
          <img
            src={greenCheck.src}
            alt={greenCheck.alt}
            style={classes.greenCheck}
          />
          <Typography sx={classes.typography}>{topics[0]}</Typography>
        </Box>
        <Box sx={classes.innerBox}>
          <img
            src={greenCheck.src}
            alt={greenCheck.alt}
            style={classes.greenCheck}
          />
          <Typography sx={classes.typography}>{topics[1]}</Typography>
        </Box>
      </Box>

      <Box sx={classes.child}>
        <Box sx={classes.innerBox}>
          <img
            src={greenCheck.src}
            alt={greenCheck.alt}
            style={classes.greenCheck}
          />
          <Typography sx={classes.typography}>{topics[2]}</Typography>
        </Box>

        <Box sx={classes.innerBox}>
          <img
            src={greenCheck.src}
            alt={greenCheck.alt}
            style={classes.greenCheck}
          />
          <Typography sx={classes.typography}>{topics[3]}</Typography>
        </Box>
      </Box>

      <Box sx={classes.child}>
        <Box sx={classes.innerBox}>
          <img
            src={greenCheck.src}
            alt={greenCheck.alt}
            style={classes.greenCheck}
          />
          <Typography sx={classes.typography}>{topics[4]}</Typography>
        </Box>
        <Box sx={classes.innerBox}>
          <img
            src={greenCheck.src}
            alt={greenCheck.alt}
            style={classes.greenCheck}
          />
          <Typography sx={classes.typography}>{topics[5]}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TopicsDesktop;
